import { css } from "lit"

export const posts = css`
	:host {
		display: flex;
		flex-direction: column;
		align-items: center;
		gap: 2rem;
		box-sizing: border-box;
		font-family: var(--headings-font-family);
	}
	* {
		box-sizing: border-box;
	}
	.post-list {
		width: 100%;
		display: flex;
		flex-wrap: wrap;
		gap: 1.875rem;
	}

	button {
		display: inline-flex;
		justify-content: center;
		align-items: center;
		color: #0C479D;
		text-align: center;
		font-family: var(--headings-font-family);
		font-size: 1.625rem;
		text-decoration: underline;
		text-transform: uppercase;
		background: transparent;
		font-style: normal;
		font-weight: 400;
		line-height: 120%; /* 1.35rem */
		border: none;
		cursor: pointer;
		outline: none;
		transition: 0.2s;
		margin-bottom: 1.25rem;
	}

	button:hover {
	}

	  @media screen and (min-width: 1030px) {
 
    single-post:nth-child(1) {
      width: 100%;
			height: auto;
			background-color: #0C479D;
			display: flex;
			flex-direction: row;
			border-radius: 0.3125rem;
    }

		single-post:nth-child(n + 2) {
			width: 33%;
		}

  }

	@media screen and (max-width: 1030px) {
		.post-list {
			gap: 1.25rem;
		}

		single-post:nth-child(n + 2) {
			width: 100%;
		}


	}
`
